module.exports = __webpack_public_path__ + "static/matrix2-a61654e18a48cb29b2ca0f153f3a9bd1.jpg";